export const poesia = [
    {
        src: `${process.env.PUBLIC_URL}/images/logos/react.svg`,
        alt: 'react-logo',
        text: 'React',
        url: 'https://fr.reactjs.org/'
    },
    {
        src: `${process.env.PUBLIC_URL}/images/logos/node.svg`,
        alt: 'node-logo',
        text: 'NodeJs',
        url: 'https://nodejs.org/en/'

    },
    {
        src: `${process.env.PUBLIC_URL}/images/logos/graphql.svg`,
        alt: 'graphql-logo',
        text: 'GraphQL',
        url: 'https://graphql.org/learn/'
    },
    {
        src: `${process.env.PUBLIC_URL}/images/logos/postgre.svg`,
        alt: 'postgre-logo',
        text: 'PostgreSQL',
        url: 'https://www.postgresql.org/'
    },
    {
        src: `${process.env.PUBLIC_URL}/images/logos/gitlab.svg`,
        alt: 'gitlab-logo',
        text: 'GitLab',
        url: 'https://about.gitlab.com/'
    },
    {
        src: `${process.env.PUBLIC_URL}/images/logos/js.svg`,
        alt: 'javascript-logo',
        text: 'Javascript',
        url: 'https://developer.mozilla.org/fr/docs/Web/JavaScript'
    },
    {
        src: `${process.env.PUBLIC_URL}/images/logos/ts.svg`,
        alt: 'ts-logo',
        text: 'Typescript',
        url: 'https://www.typescriptlang.org/'
    },    
];